"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StorageObject = /** @class */ (function () {
    function StorageObject() {
        var _this = this;
        this.storage = {};
        this.getItem = function (key) { return _this.storage[key]; };
        this.key = function (index) { return _this.storage[Object.keys(_this.storage)[index]]; };
    }
    Object.defineProperty(StorageObject.prototype, "length", {
        get: function () {
            return Object.keys(this.storage).length;
        },
        enumerable: false,
        configurable: true
    });
    StorageObject.prototype.setItem = function (key, value) {
        this.storage[key] = value;
    };
    StorageObject.prototype.clear = function () {
        this.storage = {};
    };
    StorageObject.prototype.removeItem = function (key) {
        delete this.storage[key];
    };
    return StorageObject;
}());
exports.default = StorageObject;
//# sourceMappingURL=storageObject.js.map